import React from "react";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { CustomTooltip } from "./CustomTooltip";

// import type { ChartProps } from '../Charts.types';

export const LinesChart = ({
  data,
  dataKey,
  dataset,
  showLegend,
  size,
  tickAngle,
  domain,
}) => {
  return (
    <ResponsiveContainer width="100%" height={size?.height || 300}>
      <LineChart
        data={data}
        margin={{
          top: 0,
          right: 0,
          left: -20,
          bottom: 0,
        }}
      >
        <CartesianGrid vertical={false} />
        <XAxis
          dataKey={dataKey.xAxis}
          padding={{right:20, left: 20}}
          tickLine={false}
          axisLine={false}
          angle={tickAngle?.xAxis}
          interval={1}
        />
        <YAxis
          domain={domain?.yAxis}
          tickLine={false}
          axisLine={false}
          angle={tickAngle?.yAxis}
        />
        <Tooltip content={<CustomTooltip />} />
        {showLegend == true && <Legend />}
        {(dataset || []).map((set, index) => (
          <Line
            key={index}
            type="natural"
            dataKey={set.dataKey}
            stroke={set.color}
            strokeWidth={2}
            dot={{ fill: set.color }}
            activeDot={{ r: 6 }}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
};
